import React from "react";
import Collapse from "@material-ui/core/Collapse";

const AnimationWrapper = ({ className, isVisible, ...props }) => {
  return (
    <Collapse
      in={Boolean(isVisible)}
      classes={{
        container: className,
        entered: "d-block",
        hidden: "d-none",
      }}
    >
      {props.children}
    </Collapse>
  );
};

export default AnimationWrapper;
